import{i as initialize}from"./neutron-global-92615162.js";var globalScripts=initialize;export{globalScripts as g};